"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const ShadowOverlayWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    top: 0,
    position: 'fixed',
    backgroundColor: 'modalShadow',
    width: '100%',
    height: '200%',
    zIndex: 1,
}));
const ShadowOverlayChildren = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'relative',
    flex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: ['flex-end', 'center'],
    justifyContent: 'center',
    zIndex: 2,
    pointerEvents: 'none',
    '& > *': {
        pointerEvents: 'auto',
    },
    padding: 
    // eslint-disable-next-line i18next/no-literal-string
    'env(safe-area-inset-top, 10px) env(safe-area-inset-right, 10px) env(safe-area-inset-bottom, 10px) env(safe-area-inset-left, 10px)',
}));
const ShadowOverlay = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ShadowOverlayWrapper, Object.assign({ className: "shadow-overlay", "data-id": "shadow-overlay" }, rest)),
        children && (react_1.default.createElement(ShadowOverlayChildren, { className: `shadow-overlay-children ${className || ''}` }, children))));
};
exports.default = ShadowOverlay;
//# sourceMappingURL=ShadowOverlay.js.map